// Vendor imports
const _ = require('lodash')
// Shared imports
const nameUtils = require('shared/name-utils')

const EXTRACT_RESULT_KEYS = [
  'title', 'description', 'image', 'md5image',
  'hostname', 'hash', 'url', 'url_id', 'count'
]

function articleFromExtractResult(extractResult) {
  const article = _.pick(extractResult, EXTRACT_RESULT_KEYS)
  return _.assign(article, {
    title: article.title || article.url,
    count: article.count || 1,
    timestamp: Date.now()
  })
}

function prettyPath(hash, title) {
  return '/!' + hash + (title ? ':' + nameUtils.prettyUrl(title) : '')
}

function prettySharePath(hash, title) {
  return '/share/' + hash + (title ? ':' + nameUtils.prettyUrl(title) : '')
}

function urlDataBody(urlObj) {
  return {
    'url_id': urlObj['url_id'],
    subtype: urlObj.subtype,
    title: urlObj.title,
    description: urlObj.description,
    md5image: urlObj.md5image || urlObj.image,
    image: urlObj.image,
    hostname: urlObj.hostname,
    url: urlObj.url,
    timestamp: urlObj.timestamp,
    hasMix: urlObj.hasMix,
    isMixed: urlObj.isMixed,
    isCurated: urlObj.isCurated,
    hash: urlObj.hash || urlObj['url_hash'],
    categories: urlObj.categories
  }
}

module.exports = {
  articleFromExtractResult,
  prettyPath,
  prettySharePath,
  urlDataBody
}
